import type { HarGrpcBodyView } from '@terra/shared-utils';
import type { HttpEditorProps } from '../http-editor/types';

export const buildHarDisplayEditorProps = ({
  showProtocolBodyViewToggle,
  bodyView,
  onBodyViewChange,
  toggleDisabled,
}: {
  showProtocolBodyViewToggle: boolean;
  bodyView: HarGrpcBodyView;
  onBodyViewChange: (view: HarGrpcBodyView) => void;
  toggleDisabled?: boolean;
}): Pick<
  HttpEditorProps,
  | 'showGrpcBodyViewToggle'
  | 'grpcBodyView'
  | 'onGrpcBodyViewChange'
  | 'grpcBodyViewToggleDisabled'
> => {
  if (!showProtocolBodyViewToggle) {
    return {};
  }

  return {
    showGrpcBodyViewToggle: true,
    grpcBodyView: bodyView,
    onGrpcBodyViewChange: onBodyViewChange,
    grpcBodyViewToggleDisabled: toggleDisabled,
  };
};
